import React, { useState } from "react";

import axios from "axios";

import { useNavigate } from "react-router-dom";

import swal from "sweetalert";

const Login = () => {

    let navigate = useNavigate();

    const [formData, setFormData] = useState({
        email: '',
        password: '',
        error_list: [],
    });

    const handeInput = (e) => {
        e.persist();
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }

    const handleFormSubmit = (e) => {
        e.preventDefault();

        let data = JSON.stringify({
            name: formData.name,
            email: formData.email,
            password: formData.password
        });

        axios.get('/sanctum/csrf-cookie').then(response => {

            axios.post("api/login", data)
                .then(res => {
                    if (res.data.status === 200) {
                        localStorage.setItem("auth_token", res.data.token);
                        localStorage.setItem("auth_name", res.data.username);
                        swal("Success", res.data.message, "success");
                        if (res.data.role === "admin") {
                            navigate('/admin/');
                        } else {
                            navigate('/');
                        }
                    } else if (res.data.status === 401) {
                        swal("Warning", res.data.message, "warning");
                    } else {
                        setFormData({ ...formData, error_list: res.data.validation_errors });
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        });
    }

    return (
        <>
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-header">
                                <h4>Login</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleFormSubmit}>
                                    <div className="form-group mb-3">
                                        <label>Email</label>
                                        <input type="text" onChange={handeInput} name="email" value={formData.email} className="form-control" />
                                        <span>{formData.error_list.email}</span>
                                    </div>
                                    <div className="form-group mb-3">
                                        <label>Password</label>
                                        <input type="password" onChange={handeInput} name="password" value={formData.password} className="form-control" />
                                        <span>{formData.error_list.password}</span>
                                    </div>
                                    <div className="form-group mb-3">
                                        <button type="submit" className="btn btn-primary">Login</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Login;